import { Toaster as HotToaster } from 'react-hot-toast';
import { tokens } from '@/styles/tokens';

export function Toaster() {
  return (
    <HotToaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        duration: 4000,
        // All visual styling comes from design tokens (Tailwind classNames).
        className: 'bg-card text-card-foreground border border-border shadow-dropdown rounded-lg',

        // Per-state classNames (override only the parts that differ).
        success: {
          duration: 4000,
          className:
            'bg-card text-card-foreground border border-success-emerald shadow-dropdown rounded-lg',
          // iconTheme requires literal color strings — pulled from the central
          // JS token mirror in `@/styles/tokens` (sourced from tailwind.config.js).
          iconTheme: {
            primary: tokens.successEmerald,
            secondary: tokens.bodyInverse,
          },
        },
        error: {
          duration: 5000,
          className:
            'bg-card text-card-foreground border border-danger-red shadow-dropdown rounded-lg',
          iconTheme: {
            primary: tokens.dangerRed,
            secondary: tokens.bodyInverse,
          },
        },
        loading: {
          className: 'bg-card text-card-foreground border border-border shadow-dropdown rounded-lg',
        },
      }}
    />
  );
}
